import Main from "../components/layout/Main";
import ProtectedRoute from "../components/comps/protected_route";
import InspectionManagement from "../pages/academics/inspections/InspectionManagement";
import StudentsManagement from "../pages/academics/students/StudentsManagement";
import CircularsManagement from "../pages/academics/circulars/CircularsManagement";
import HolidayPackagesManagement from "../pages/academics/holiday_packages/HolidayPackagesManagement";
import ClassTeacherAssignment from "../pages/academics/class_teachers/ClassTeacherAssignment";
import CurricularCalendarsManagement from "../pages/academics/curricular_calendars/CurricularCalendarsManagement";
import ActivityParticipationManagement from "../pages/academics/activity_participation/ActivityParticipationManagement";
import CoCurricularDashboard from "../pages/academics/co_curricular_dashboard/CoCurricularDashboard";
import BursaryGiantsManagement from "../pages/academics/bursary_giants/BursaryGiantsManagement";
import DisciplineManagement from "../pages/academics/discipline/DisciplineManagement";
import AggregationRunsManagement from "../pages/academics/aggregation_runs/AggregationRunsManagement";
import AcademicAnalysisDashboard from "../pages/academics/academic_analysis/AcademicAnalysisDashboard";
import AnalysisReportsManagement from "../pages/academics/analysis_reports/AnalysisReportsManagement";
import AppraisalManagement from "../pages/academics/appraisal/AppraisalManagement";

const academicsRoutes = [
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <Main />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "academics/appraisal",
        element: (
          <ProtectedRoute>
            <AppraisalManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "academics/students",
        element: (
          <ProtectedRoute>
            <StudentsManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "academics/inspections",
        element: (
          <ProtectedRoute>
            <InspectionManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "academics/circulars",
        element: (
          <ProtectedRoute>
            <CircularsManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "academics/holiday-packages",
        element: (
          <ProtectedRoute>
            <HolidayPackagesManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "academics/assign_class_teacher",
        element: (
          <ProtectedRoute>
            <ClassTeacherAssignment />
          </ProtectedRoute>
        ),
      },
      {
        path: "academics/curricular-calendars",
        element: (
          <ProtectedRoute>
            <CurricularCalendarsManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "academics/activity-participation",
        element: (
          <ProtectedRoute>
            <ActivityParticipationManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "academics/co-curricular-dashboard",
        element: (
          <ProtectedRoute>
            <CoCurricularDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "academics/bursary-giants",
        element: (
          <ProtectedRoute>
            <BursaryGiantsManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "academics/discipline",
        element: (
          <ProtectedRoute>
            <DisciplineManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "academics/aggregation-runs",
        element: (
          <ProtectedRoute>
            <AggregationRunsManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "academics/analysis-dashboard",
        element: (
          <ProtectedRoute>
            <AcademicAnalysisDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "academics/analysis-reports",
        element: (
          <ProtectedRoute>
            <AnalysisReportsManagement />
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export default academicsRoutes;
